import { Component, effect, OnInit } from '@angular/core';
import { Router, RouterOutlet, NavigationStart } from '@angular/router';
import { ToastComponent } from './shared/toast/toast.component.ts/toast.component';
import { LoaderComponent } from './shared/loader/loader.component';
import { AuthService } from './core/auth/services/auth.service';
import { I18nService } from './core/i18n/i18n.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastComponent, LoaderComponent],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  constructor(private router: Router, private auth: AuthService, private i18n: I18nService) {
    effect(() => {
      this.i18n.currentLanguage();
      document.title = this.i18n.t('layout.platformName');
    });
  }

  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (this.auth.accessToken() && this.auth.isTokenExpired()) {
          // Store attempted route so user returns here after logging in again.
          this.auth.setReturnUrl(event.url);
          this.auth.logout(true);
        }
      }
    });
  }

}
